import PropTypes from "prop-types";
import React from "react";

function ItemTimelineVertical({ titulo, icone, cor = "primary", children }) {
  return (
    <li className="event-list">
      <div className="event-timeline-dot">
        <i className="bx bx-right-arrow-circle"></i>
      </div>
      <div className="d-flex">
        <div className="flex-shrink-0 me-3">
          <i className={`${icone} h2 text-${cor}`}></i>
        </div>
        <div className="flex-grow-1">
          <div>
            <h5>{titulo}</h5>
            {children}
          </div>
        </div>
      </div>
    </li>
  );
}

ItemTimelineVertical.propTypes = {
  titulo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icone: PropTypes.string.isRequired,
  cor: PropTypes.string,
  children: PropTypes.node,
};

export default ItemTimelineVertical;
